module.exports = "<div data-refuse-key-nav=\"true\"></div>\n"